import { useAtom } from "jotai";
import { RefObject } from "react";
import { GridApiPro } from "@mui/x-data-grid-pro";
import { segmentsDataGridApiAtom } from "@/state/jotai/atom/segmentsDataGridApiAtom.ts";

function useSegmentsDataGridApi(): [RefObject<GridApiPro | null> | null, (newValue: RefObject<GridApiPro | null>) => void] {
  const [refObject, setRefObject] = useAtom(segmentsDataGridApiAtom);

  return [
    refObject,
    setRefObject
  ];
}

export default useSegmentsDataGridApi;
